import AutocompleteStyled from "@/components/AutocompleteStyled";
import { useLocationSubcategories } from "@/lib/api";
import { Skeleton } from "@mui/material";

export const LocationSubcategorySelector = ({
  name,
  defaultValue,
  onChange,
  label,
  placeholder,
  hint,
  required = false,
  idFilter = null,
}) => {
  const { locationSubcategories, isLoading } = useLocationSubcategories();

  const handleSelected = (event, value) => {
    event.target.name = name;
    event.target.value = value?.id;
    if (onChange) {
      onChange(event, value);
    }
  };

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <AutocompleteStyled
      name={name}
      label={label}
      hint={hint}
      options={locationSubcategories.filter((sc) => {
        if (!idFilter) {
          return true;
        }

        return idFilter.indexOf(sc.id + "") > -1;
      })}
      placeholder={placeholder}
      required={required}
      onChange={handleSelected}
      defaultValue={defaultValue}
      getOptionLabel={(option) => `${option.name}`}
    />
  );
};
